export default __webpack_public_path__ + "static/star-4f03df528b90eecc9124e7be086f8158.mp4";